/*
 * <consent-gate> — Mesafeli satis sozlesmesi onay kutusu kapisi.
 *
 * Birincil bariyer, checkbox uzerindeki HTML5 `required` ozelligidir; bu
 * sayede kutu isaretlenmeden form (ve dolayisiyla "Odemeye gec") gonderilemez,
 * JavaScript devre disi olsa bile. Bu bilesen yalnizca gorsel bir gelistirmedir:
 * kutu isaretlenene kadar odeme butonunu kilitli gosterir.
 */
class ConsentGate extends HTMLElement {
  constructor() {
    super();
    this.checkbox = this.querySelector('input[type="checkbox"]');
    this.button = this.dataset.checkoutButton
      ? document.getElementById(this.dataset.checkoutButton)
      : null;
  }

  connectedCallback() {
    if (!this.checkbox || !this.button) return;
    this.onChange = this.onChange.bind(this);
    this.checkbox.addEventListener('change', this.onChange);
    this.onChange();
  }

  disconnectedCallback() {
    if (this.checkbox) this.checkbox.removeEventListener('change', this.onChange);
  }

  onChange() {
    // Sepet bos oldugu icin zaten disabled olan butona dokunma; sadece
    // bos olmayan sepette onay durumuna gore kilit sinifini ac/kapat.
    if (this.button.disabled) return;
    const locked = !this.checkbox.checked;
    this.button.classList.toggle('cart__checkout-button--locked', locked);
    this.button.setAttribute('aria-disabled', locked ? 'true' : 'false');
  }
}

if (!customElements.get('consent-gate')) {
  customElements.define('consent-gate', ConsentGate);
}
